import { Controller } from "stimulus"

// Nieuwe ticket 3 (#1354): live voorbeeld van de sportersomgeving op
// Instellingen > Sportersomgeving. Zet dezelfde --cc-*-tokens als de server
// (ApplicationHelper#cc_theme_style_tag) op het voorbeeld, zodat het bedrijf
// ziet wat een kleur doet voordat het opslaat.
export default class extends Controller {
  static targets = ["telefoon", "primair", "accent", "naam", "naamVeld", "welkom", "welkomVeld"]

  kiesPrimair(event) {
    this.primairTarget.value = event.target.value.toUpperCase()
    this.ververs()
  }

  kiesAccent(event) {
    this.accentTarget.value = event.target.value.toUpperCase()
    this.ververs()
  }

  naam() {
    const waarde = this.naamVeldTarget.value.trim()
    this.naamTarget.textContent = waarde || this.naamVeldTarget.placeholder || "Coach Connect"
  }

  welkom() {
    const tekst = this.welkomVeldTarget.value.trim()
    this.welkomTarget.textContent = tekst
    this.welkomTarget.hidden = tekst.length === 0
  }

  ververs() {
    const primair = this.geldig(this.primairTarget.value) || this.primairTarget.placeholder
    const accentIngevuld = this.geldig(this.accentTarget.value)
    const stijl = this.telefoonTarget.style
    if (this.geldig(primair)) {
      stijl.setProperty("--cc-primary", primair)
      stijl.setProperty("--cc-primary-strong", this.leesbaarOpWit(primair))
      stijl.setProperty("--cc-primary-soft", this.tint(primair, 0.42))
      if (!accentIngevuld) stijl.setProperty("--cc-accent", this.tint(primair, -0.14))
    }
    if (accentIngevuld) stijl.setProperty("--cc-accent", accentIngevuld)
  }

  geldig(waarde) {
    const w = (waarde || "").trim()
    return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(w) ? w : null
  }

  // Zelfde rekenwijze als cc_tint en cc_leesbaar_op_wit in ApplicationHelper.
  tint(hex, stap) {
    const [h, s, l] = this.naarHsl(hex)
    return this.naarHex(h, s, Math.min(0.96, Math.max(0.05, l + stap)))
  }

  leesbaarOpWit(hex) {
    let [h, s, l] = this.naarHsl(hex)
    let kleur = this.naarRgb(hex)
    while (this.contrastMetWit(kleur) < 4.5 && l > 0.1) {
      l -= 0.01
      kleur = this.naarRgb(this.naarHex(h, s, l))
    }
    return this.naarHex(h, s, l)
  }

  contrastMetWit(rgb) {
    const [r, g, b] = rgb.map((c) => {
      const v = c / 255
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
    })
    const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b
    return 1.05 / (lum + 0.05)
  }

  naarRgb(hex) {
    let w = hex.replace("#", "")
    if (w.length === 3) w = w.split("").map((c) => c + c).join("")
    return [0, 2, 4].map((i) => parseInt(w.substr(i, 2), 16))
  }

  naarHsl(hex) {
    const [r, g, b] = this.naarRgb(hex).map((c) => c / 255)
    const max = Math.max(r, g, b)
    const min = Math.min(r, g, b)
    const l = (max + min) / 2
    if (max === min) return [0, 0, l]
    const d = max - min
    const s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    let h
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0)
    else if (max === g) h = (b - r) / d + 2
    else h = (r - g) / d + 4
    return [h / 6, s, l]
  }

  naarHex(h, s, l) {
    const naar = (p, q, t) => {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < 1 / 6) return p + (q - p) * 6 * t
      if (t < 1 / 2) return q
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
      return p
    }
    let rgb
    if (s === 0) {
      rgb = [l, l, l]
    } else {
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s
      const p = 2 * l - q
      rgb = [naar(p, q, h + 1 / 3), naar(p, q, h), naar(p, q, h - 1 / 3)]
    }
    return "#" + rgb.map((c) => Math.round(c * 255).toString(16).padStart(2, "0")).join("").toUpperCase()
  }
}
